import { useTheme } from '../../';
import MasonryComponent from 'react-masonry-component';
import React, { Fragment, useRef } from 'react';
import componentQueries from 'react-component-queries';
import debounce from 'lodash/debounce';
const MasonryCore = ({ items, children, numCols }) => {
    const theme = useTheme();
    const masonryRef = useRef(null);
    const rerender = debounce(() => {
        masonryRef && masonryRef.current && masonryRef.current.forceUpdate();
    }, 100);
    const gutter = theme.spacing(3);
    const pct = 100 / numCols;
    const offset = ((numCols - 1) * gutter) / numCols;
    const widthCalc = numCols > 1 ? `calc(${pct}% - ${offset}px)` : '100%';
    const nodeMapFn = (thing, index) => {
        const ResizeSensor = require('resize-sensor');
        return (React.createElement("div", { key: index, ref: el => el && new ResizeSensor(el, rerender), style: { marginBottom: gutter, width: widthCalc } }, thing));
    };
    return (React.createElement(Fragment, null,
        React.createElement("div", { style: { height: 0, opacity: 0 } },
            numCols,
            "\u00A0"),
        React.createElement(MasonryComponent, { options: { gutter, percentPosition: true, transitionDuration: 0 }, style: { margin: `${gutter} ${gutter} 0`, position: 'relative' }, ref: masonryRef }, items ? items.map(nodeMapFn) : React.Children.map(children, nodeMapFn))));
};
export const Masonry = componentQueries({
    queries: [
        function (size, props) {
            return { numCols: Math.floor(size.width / 400) };
        },
    ],
})(MasonryCore);
//# sourceMappingURL=Masonry.js.map